export const state = {
  mainTime: 0,
  pendingRequests: {},
  error: {
    cmd: false,
    error: false
  },
  appReady: false,
  currentRoomUuid: '',
  loginData: {
    request: {
      cmd: 'login',
      login: '',
      password: ''
    },
    error: {
      cmd: 'login',
      error: ''
    }
  },

  askAuthentication: {
    request: {
      cmd: 'send_message',
      room: '',
      content: '',
      rich_content: []
    }
  },

  updateOwnSettings: {
    request: {
      cmd: 'settings',
      update: {
        last_name: '',
        first_name: '',
        want_notif: true,
        want_daily_report: false
      }
    }
  },

  ownSettings: {
    request: {
      cmd: 'settings'
    },
    response: {
      cmd: 'settings',
      data: {
        uuid: '',
        kind: '',
        email: '',
        first_name: '',
        last_name: '',
        last_login: null,
        skills: [
          {
            uuid: '',
            label: ''
          }
        ],
        paused: false,
        max_rooms: 0,
        want_notif: true,
        want_daily_report: true
      },
      error: []
    }
  },

  agentSettings: {
    request: {
      cmd: 'supervisor_settings',
      uuid: ''
    },
    response: {
      cmd: 'supervisor_settings',
      data: {
        uuid: '',
        kind: 'agent',
        email: '',
        first_name: '',
        last_name: '',
        last_login: '',
        skills: [],
        paused: false,
        max_rooms: 8
      }
    }
  },

  ping: {
    request: {
      cmd: 'ping'
    },
    response: {
      cmd: 'pong'
    }
  },

  pause: {
    request: {
      cmd: 'pause',
      pause: true
    }
  },

  allAgents: {
    request: {
      cmd: 'get_agents',
      skill: ''
    },
    response: {
      cmd: 'get_agents',
      data: []
    }
  },

  allSkills: {
    request: {
      cmd: 'get_skills'
    },
    response: {
      cmd: 'get_skills',
      data: []
    }
  },

  allRooms: {
    request: {
      cmd: 'get_rooms'
    },
    response: {
      cmd: 'get_rooms',
      data: []
    }
  },

  joinRoom: {
    request: {
      cmd: 'join_room',
      room: ''
    },
    response: {
      cmd: 'join_room',
      room: '',
      history: []
    }
  },

  closeRoom: {
    request: {
      cmd: 'close_room',
      room: ''
    },
    response: {
      cmd: 'close_room',
      room: '',
      result: ''
    }
  },

  blockRoom: {
    request: {
      cmd: 'block_room',
      room: ''
    },
    response: {
      cmd: 'block_room',
      room: '',
      result: ''
    }
  },

  transferRoom: {
    request: {
      cmd: 'transfer_room',
      skill: '',
      room: ''
    },
    response: {
      cmd: 'transfer_room',
      room: '',
      skill: '',
      result: ''
    }
  },

  sendMessage: {
    request: {
      cmd: 'send_message',
      room: '',
      content: '',
      rich_content: []
    },
    response: {
      cmd: 'send_message',
      room: '',
      result: 'success',
      event: ''
    }
  },

  sendProducts: {
    request: {
      cmd: 'send_message',
      room: '',
      content: '',
      rich_content: []
    }
  },

  sendLocations: {
    request: {
      cmd: 'send_message',
      room: '',
      content: '',
      rich_content: []
    }
  },

  sendPayment: {
    request: {
      cmd: 'send_message',
      room: '',
      content: '',
      rich_content: []
    }
  },

  sendFiles: {
    request: {
      cmd: 'send_message',
      room: '',
      content: '',
      rich_content: []
    }
  },

  getHistory: {
    request: {
      cmd: 'get_history',
      room: ''
    },
    response: {
      cmd: 'get_history',
      room: '',
      data: []
    }
  },

  messages: {
    request: {
      cmd: 'get_messages',
      room: '',
      lastevent: null,
      fromevent: null
    },
    response: {
      room: '',
      messages: []
    }
  },

  resetPassword: {
    errors: []
  },

  changePassword: {
    errors: []
  },

  getProducts: {
    request: {
      cmd: 'get_products'
    },
    response: {
      cmd: 'get_products',
      data: []
    }
  },

  getHeaderStats: {
    request: {
      cmd: 'get_header_stats'
    },
    response: {
      cmd: 'get_header_stats',
      data: {
        running_count: 0,
        average_waiting: 0,
        average_running: 0,
        average_sat: 0
      }
    }
  },

  intervals: [
    'today',
    'yesterday',
    'lastweek',
    'thismonth'
  ],

  getStats: {
    request: {
      cmd: 'get_stats',
      interval: null
    },
    response: {
      cmd: 'get_stats',
      data: {
        waiting_count: 5,
        average_waiting: 20,
        average_running: 80,
        handle_rate: 40,
        closed_count: 2,
        details: [
          {
            agent: null,
            skill: 'Skill1',
            state: 'waiting',
            created: 1522411200
          }
        ]
      }
    }

  },

  getCsvStats: {
    request: {
      cmd: 'get_csv_stats',
      interval: null
    },
    response: {
      cmd: 'get_csv_stats',
      data: ''
    }

  },

  getSupervisorStats: {
    request: {
      cmd: 'get_supervisor_stats',
      interval: null,
      agent: null,
      skill: null
    },
    response: {
      cmd: 'get_supervisor_stats',
      data: {
        waiting_count: 0,
        average_waiting: 0,
        average_running: 0,
        agent_count: 0,
        handle_rate: 0,
        closed_count_per_agent: 0,
        details: []
      }
    }
  },

  getSupervisorCsvStats: {
    request: {
      cmd: 'get_supervisor_csv_stats',
      interval: null,
      agent: null,
      skill: null
    },
    response: {
      cmd: 'get_supervisor_csv_stats',
      data: {}
    }
  },

  getNotes: {
    request: {
      cmd: 'get_notes',
      room: null
    },
    response: {
      cmd: 'get_notes',
      room: '',
      data: [
        {
          uuid: 'baa04e67-2482-4602-b5d9-1af8e8008cec',
          created: 1535537413,
          room: 'cd61c1c4-3169-4b06-bd52-a038833c7907',
          agent_uuid: 'e6f005dd-bb70-44d5-aeb1-06242d1ce12f',
          agent_email: 'agent1@test.com',
          subject: 'test',
          content: 'this is a test'
        }
      ]
    }
  },

  sendNote: {
    request: {
      cmd: 'add_note',
      room: '',
      subject: '',
      content: ''
    },
    response: {
      cmd: 'add_note',
      room: '',
      result: ''
    }
  },

  getZencalls: {
    request: {
      'cmd': 'get_zencalls'
    },
    response: {
      cmd: 'get_zencalls',
      data: [
        {
          uuid: '',
          label: ''
        }
      ]
    }
  },

  launchZencall: {
    request: {
      cmd: 'launch_zencall',
      room: '',
      zencall: ''
    },
    response: {
      cmd: 'launch_zencall',
      room: '',
      zencall: '',
      result: ''
    }
  },

  crm: {
    results: []
  }
}
